// src/pages/ImportWorkflow.jsx
import React from 'react';
import ZoomableImage from '../components/ZoomableImage';
import './Workflows.css';

export default function ImportWorkflow() {
  const svgPath = '/svgs/nesim-import-workflow.svg';

  return (
    <div className="workflow-page">
      <h1>NESIM Import Workflow</h1>
      <p>
        This diagram details our import process—from supplier selection and shipping logistics to quality assurance and delivery—to ensure timely access to brewing ingredients.
      </p>

      <div className="svg-container">
        <ZoomableImage src={svgPath} alt="NESIM Import Workflow" />
      </div>

      <div className="download-container">
        <a
          href={svgPath}
          download="nesim-import-workflow.svg"
          className="download-button"
        >
          Download SVG
        </a>
      </div>
    </div>
  );
}
